/**
 * You May Also Like v1 — Figma carousel (header arrows)
 * Desktop Quick Add matches Collection Raf (hover → sizes → cart + drawer)
 */
(function () {
  'use strict';

  function cartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) return theme.routes.cartAdd;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + (root.slice(-1) === '/' ? '' : '/') + 'cart/add.js';
  }

  function addVariantToCart(variantId) {
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) {
          var msg = (body && (body.description || body.message)) || 'Could not add to cart';
          throw new Error(msg);
        }
        return body;
      });
    });
  }

  function openCartDrawer(detail) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: detail, bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart-drawer:open', { detail: detail, bubbles: true }));
    if (window.CartDrawerRaf && typeof window.CartDrawerRaf.open === 'function') {
      window.CartDrawerRaf.open();
    }
    if (window.theme && theme.cart && typeof theme.cart.getCart === 'function') {
      theme.cart.getCart();
    }
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-ymalv1-track]');
    var prev = root.querySelector('[data-ymalv1-prev]');
    var next = root.querySelector('[data-ymalv1-next]');
    if (!track) return;

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function update() {
      var max = maxScroll();
      var can = max > 2;
      if (prev) {
        prev.disabled = !can || track.scrollLeft <= 1;
        prev.setAttribute('aria-disabled', String(prev.disabled));
      }
      if (next) {
        next.disabled = !can || track.scrollLeft >= max - 1;
        next.setAttribute('aria-disabled', String(next.disabled));
      }
      root.classList.toggle('ymalv1--scrollable', can);
    }

    function scrollByCard(dir) {
      var card = track.querySelector('.ymalv1-card');
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 12;
      var w = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.5;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });
    update();
  }

  function initQuickAdd(root) {
    function getVariantData(card) {
      var el = card.querySelector('[data-ymalv1-variant-data]');
      if (!el) return [];
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return [];
      }
    }

    function optionKey(position) {
      if (String(position) === '1') return 'option1';
      if (String(position) === '2') return 'option2';
      if (String(position) === '3') return 'option3';
      return '';
    }

    function findVariant(variants, sizePos, sizeValue, colorPos, colorValue) {
      var sizeKey = optionKey(sizePos);
      var colorKey = optionKey(colorPos);
      var exactUnavailable = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (sizeKey && v[sizeKey] !== sizeValue) continue;
        if (colorKey && colorValue && v[colorKey] !== colorValue) continue;
        if (v.available) return v;
        if (!exactUnavailable) exactUnavailable = v;
      }
      return exactUnavailable;
    }

    function syncSizesForColor(card, colorValue) {
      var variants = getVariantData(card);
      var sizePos = card.getAttribute('data-size-position');
      var colorPos = card.getAttribute('data-color-position');
      if (colorValue) card.setAttribute('data-selected-color', colorValue);

      card.querySelectorAll('[data-ymalv1-size]').forEach(function (btn) {
        var sizeValue = btn.getAttribute('data-size-value');
        var match = findVariant(variants, sizePos, sizeValue, colorPos, colorValue || card.getAttribute('data-selected-color'));
        btn.classList.remove('is-active');
        if (match && match.available) {
          btn.setAttribute('data-variant-id', String(match.id));
          btn.classList.remove('is-unavailable');
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
        } else {
          btn.removeAttribute('data-variant-id');
          btn.classList.add('is-unavailable');
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
        }
      });
    }

    function resetSizeButtons(card) {
      var color = card.getAttribute('data-selected-color') || '';
      var sizes = card.querySelector('[data-ymalv1-sizes]');
      if (sizes) sizes.classList.remove('is-loading');
      card.querySelectorAll('[data-ymalv1-size]').forEach(function (btn) {
        btn.classList.remove('is-loading', 'is-active');
      });
      if (card.querySelector('[data-ymalv1-size]')) {
        syncSizesForColor(card, color);
      }
    }

    function updateCardImage(card, imageUrl) {
      if (!imageUrl) return;
      var img = card.querySelector('.ymalv1-card__img:not(.ymalv1-card__img--ph)');
      if (!img || img.tagName !== 'IMG') return;
      img.src = imageUrl;
      if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
    }

    function closeAllQuick(exceptCard) {
      root.querySelectorAll('.ymalv1-card.is-quick-open').forEach(function (card) {
        if (exceptCard && card === exceptCard) return;
        card.classList.remove('is-quick-open');
        var sizes = card.querySelector('[data-ymalv1-sizes]');
        var trigger = card.querySelector('[data-ymalv1-quick-trigger]');
        if (sizes) sizes.hidden = true;
        if (trigger) trigger.hidden = false;
        resetSizeButtons(card);
      });
    }

    function openSizes(card) {
      closeAllQuick(card);
      var sizes = card.querySelector('[data-ymalv1-sizes]');
      var trigger = card.querySelector('[data-ymalv1-quick-trigger]');
      if (!sizes) return;
      resetSizeButtons(card);
      card.classList.add('is-quick-open');
      if (trigger) trigger.hidden = true;
      sizes.hidden = false;
    }

    function setLoading(card, on, activeBtn) {
      var sizes = card.querySelector('[data-ymalv1-sizes]');
      if (sizes) sizes.classList.toggle('is-loading', !!on);
      card.querySelectorAll('[data-ymalv1-size]').forEach(function (btn) {
        var isChosen = !!(on && activeBtn && btn === activeBtn);
        btn.classList.toggle('is-loading', isChosen);
        btn.classList.toggle('is-active', isChosen);
        if (on) {
          btn.disabled = true;
        } else if (btn.classList.contains('is-unavailable') || !btn.getAttribute('data-variant-id')) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
        }
      });
    }

    function selectSwatch(swatch) {
      if (!swatch || swatch.disabled || swatch.classList.contains('is-unavailable')) return;
      var swatchCard = swatch.closest('.ymalv1-card');
      if (!swatchCard) return;

      var colorValue = swatch.getAttribute('data-color-value') || '';
      swatchCard.querySelectorAll('[data-ymalv1-swatch]').forEach(function (s) {
        var on = s === swatch;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      syncSizesForColor(swatchCard, colorValue);

      var imageUrl = swatch.getAttribute('data-image');
      if (imageUrl) {
        window.requestAnimationFrame(function () {
          updateCardImage(swatchCard, imageUrl);
        });
      }

      var direct = swatchCard.querySelector('[data-ymalv1-quick-direct]');
      if (direct) {
        var variants = getVariantData(swatchCard);
        var colorPos = swatchCard.getAttribute('data-color-position');
        var colorKey = optionKey(colorPos);
        var found = null;
        for (var i = 0; i < variants.length; i++) {
          if (colorKey && variants[i][colorKey] === colorValue && variants[i].available) {
            found = variants[i];
            break;
          }
        }
        if (found) direct.setAttribute('data-variant-id', String(found.id));
      }

      if (typeof swatch.blur === 'function') swatch.blur();
    }

    root.addEventListener(
      'click',
      function (e) {
        var swatch = e.target.closest('[data-ymalv1-swatch]');
        if (swatch && root.contains(swatch)) {
          e.preventDefault();
          e.stopPropagation();
          selectSwatch(swatch);
          return;
        }

        var trigger = e.target.closest('[data-ymalv1-quick-trigger]');
        if (trigger && root.contains(trigger)) {
          e.preventDefault();
          e.stopPropagation();
          var card = trigger.closest('.ymalv1-card');
          if (!card) return;

          if (trigger.hasAttribute('data-ymalv1-quick-direct')) {
            var directId = trigger.getAttribute('data-variant-id');
            if (!directId || trigger.disabled) return;
            trigger.disabled = true;
            addVariantToCart(directId)
              .then(function (body) {
                openCartDrawer(body);
              })
              .catch(function (err) {
                if (typeof console !== 'undefined' && console.warn) {
                  console.warn('[You May Also Like] Quick Add failed', err);
                }
              })
              .then(function () {
                trigger.disabled = false;
              });
            return;
          }

          openSizes(card);
          return;
        }

        var sizeBtn = e.target.closest('[data-ymalv1-size]');
        if (sizeBtn && root.contains(sizeBtn)) {
          e.preventDefault();
          e.stopPropagation();
          if (sizeBtn.disabled || sizeBtn.classList.contains('is-unavailable') || !sizeBtn.getAttribute('data-variant-id')) {
            return;
          }
          var sizeCard = sizeBtn.closest('.ymalv1-card');
          if (!sizeCard) return;
          var variantId = sizeBtn.getAttribute('data-variant-id');
          setLoading(sizeCard, true, sizeBtn);
          addVariantToCart(variantId)
            .then(function (body) {
              openCartDrawer(body);
              closeAllQuick();
            })
            .catch(function (err) {
              if (typeof console !== 'undefined' && console.warn) {
                console.warn('[You May Also Like] Quick Add failed', err);
              }
              setLoading(sizeCard, false);
            });
          return;
        }

        if (!e.target.closest('.ymalv1-card.is-quick-open')) {
          closeAllQuick();
        }
      },
      true
    );

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllQuick();
    });
  }

  function init(root) {
    if (!root || root.dataset.ymalv1Ready === '1') return;
    root.dataset.ymalv1Ready = '1';
    initCarousel(root);
    initQuickAdd(root);
  }

  function boot() {
    document.querySelectorAll('[data-ymalv1]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // BCo (10-9-26): when the theme swaps in Shopify related products, re-attach the arrows to the new row.
  // (Quick Add listens on the section itself, so it keeps working.)
  document.addEventListener('recommendations:loaded', function (e) {
    var host = e.detail && e.detail.section;
    var root = host && host.querySelector('[data-ymalv1]');
    if (root) initCarousel(root);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ymalv1]');
    if (root) {
      delete root.dataset.ymalv1Ready;
      init(root);
    }
  });
})();
